<script setup lang="ts">
import { Icon } from '@iconify/vue'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(
  defineProps<{
    items: { label: string; value?: string }[]
    loading?: boolean
    columns?: number
  }>(),
  {
    columns: 4,
  }
)
</script>

<template>
  <div :class="`grid inline-grid grid-cols-${columns}`">
    <div v-for="item in items" :key="item.label" class="flex flex-col gap-2">
      <p class="component-label text-tertiary">{{ item.label }}</p>
      <div class="h-6 flex items-center">
        <Icon v-if="loading" icon="eos-icons:three-dots-loading" height="16" />
        <slot v-else-if="item.value" name="scope" v-bind="item" />
        <p v-else>-</p>
      </div>
    </div>
  </div>
</template>
